export const iconFontAwesomeTransportationRoadBarrier = (
	<i className="fa-solid fa-road-barrier"></i>
);
